import { useAppData } from '@modules/_shared/providers/AppDataProvider';

import { useIsTeamLeaderOrAdmin } from './useIsTeamLeaderOrAdmin';

export const useCanEditTeamMember = (teamId?: string, userId?: string) => {
  const { me } = useAppData();
  const canManageTeam = useIsTeamLeaderOrAdmin(teamId);

  return canManageTeam || (userId != null && userId === me?.id);
};
